<template>
  <div
    class="card rounded-lg"
    :class="[
      selectedInsurance === policy.ID ? selectedClass : 'insurance',
      !isExtra && (isActiveSlide || selectedInsurance === policy.ID)
        ? 'extra-height'
        : 'h-100',
    ]"
    @click="selectPolicy()"
  >
    <div class="card-body d-flex flex-column insurance-body">
      <div class="text-center">
        <div class="card-title">
          <div class="row justify-content-md-center align-items-center">
            <div class="col-auto insurance-header">{{ policy.Title }}</div>
            <div class="w-auto ml-2" @click.stop>
              <InfoText
                class="infotext"
                v-if="policy.Info"
                :content="policy.Info"
                :id="policy.Info.title"
                :fillColor="
                  selectedInsurance === policy.ID ? '#ffffff' : '#668C9F'
                "
                :formatHtml="true"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="previous-premium" v-if="policy.OriginalPremium">
            <span>{{ policy.OriginalPremium }}</span>
            <span>{{ mnthText }}</span>
          </div>
          <h1 class="card-subtitle">
            <span class="premium">{{ policy.Premium }}</span>
            <span>{{ mnthText }}</span>
          </h1>
        </div>
      </div>
      <div class="card-text mb-4">
        <ul>
          <li
            v-for="data in policy.CoverageData"
            :key="data.Item"
            class="list-primary"
          >
            <span class="insurance-item-space-left">
              {{ data.Item }}
            </span>
          </li>
        </ul>
      </div>
      <button
        class="btn btn-primary mt-auto mx-auto px-5 py-3 insurance-button"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';
  export default {
    components: {
      InfoText,
    },
    props: {
      policy: {
        type: Object,
        required: true,
      },
      selectedInsurance: {
        type: String,
        required: true,
      },
      buttonText: {
        type: String,
        required: true,
      },
      selectedClass: {
        type: String,
        required: true,
      },
      isExtra: {
        type: Boolean,
        required: false,
      },
      mnthText: {
        type: String,
        required: true,
      },
      activeSlide: {
        type: Number,
        required: false,
      },
    },
    methods: {
      selectPolicy() {
        if (this.selectedInsurance === this.policy.ID) {
          this.$emit('input', '');
        } else {
          this.$emit('input', this.policy.ID);
        }
        this.$emit('getInsuranceData', this.policy.ID);
      },
    },
    computed: {
      isActiveSlide() {
        const idLength = this.policy.ID.length;
        const policyId = this.policy.ID.substring(idLength - 1, idLength);
        return this.activeSlide === parseInt(policyId - 1);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .infotext {
    position: relative;
    right: 10px;
    top: -2px;
    z-index: 2;
  }
</style>
